'use strict';

module.exports = {

    // Default app for incontext
    APP: 'hermes',

    // Max time we'll wait for an iframe load
    LOADING_TIMEOUT: 5000,

    // Bridge
    BRIDGE_NAME: 'PayPalBridge',
    BRIDGE_CONTEXT_ROOT: '/webapps/{{app}}/bridge',

    // Prefetch
    PREFETCH_NAME: 'prefetch',
    PREFETCH_CONTEXT_ROOT: '/webapps/{{app}}/prefetch',

    // Third-party cookie support
    COOKIE_CHECK_NAME: 'cookiecheck',
    COOKIE_CHECK_PATH: '/webapps/{{app}}/cookiecheck',

    // One Touch Auth
    ONETOUCH_CONTEXT_ROOT: '/webapps/{{app}}/api/auth/onetouch',

    // Classes
    STATIC_BUTTON_HIDDEN_STYLE: 'paypal-button-hidden',

    // Content
    CONTENT_CLOSE_WINDOW: 'Close Window',
    CONTENT_LOADING: 'Loading...',
    CONTENT_SECURE_WINDOW: 'Don\'t see the secure PayPal browser? We\'ll help you re-launch the window to complete your purchase.',
    CONTINUE_LINK: '<a class="ppbutton" id="ppICContinue" role="button" tabindex="1" title="Relaunch secure PayPal browser">Continue <span class="frontArrow"></span></a>',

    // Device
    SUPPORTED_AGENTS: {
        Chrome: 27,
        IE: 9,
        MSIE: 9,
        Firefox: 30,
        Safari: 5.1,
        Opera: 23
    },

    // Locale
    DEFAULT_LOCALE: 'en_US',

    // Mini-browser
    MINI_BROWSER_NAME: 'PPFrame',
    MINI_BROWSER_HEIGHT: 535,
    MINI_BROWSER_WIDTH: 450,

    // One touch related
    ONETOUCH_IFRAME_ID: 'paypalOneTouchIframe',
    JS_BUTTON_TAGLINE_SPAN_STYLE: 'paypal-button-tag-content',

    // URLs
    BUTTON_JS_URL: '//www.paypalobjects.com/api/button.js',
    ONETOUCH_IFRAME_URL: '//www.paypalobjects.com/api/oneTouch.html',

    LIVE_URL_PREFIX: 'https://www.paypal.com/checkoutnow?token=',
    LIVE_URL_ROOT: 'https://www.paypal.com',

    SANDBOX_URL_PREFIX: 'https://www.sandbox.paypal.com/checkoutnow?token=',
    SANDBOX_URL_ROOT: 'https://www.sandbox.paypal.com',

    // Templates
    TEMPLATES: '$TEMPLATES$',
    ERROR_MESSAGES: {
        IC_SETUP_CALLED_TWICE: 'Error: You are calling paypal.checkout.setup() more than once. This function can only be called once per page load. Any further calls will be ignored.',
        PAYPAL_GLOBAL_OVERRIDE: 'Error: window.paypal.checkout already exists. You may have inserted the checkout.js script more than once. Ignoring further attempts to assign to window.paypal.checkout.',
        POSTMESSAGE_INVALID_ORIGIN: 'Message received from invalid domain',
        IC_SETUP_MERCHANTID_ERROR: 'Merchant id is required for setup!',
        SANDBOX_BANNER: 'PayPal Incontext is running in sandbox mode. This message will not appear in production mode',
        MISSING_EC_TOKEN: 'EC Token is not passed in url passed by ajax response',
        MINI_BROWSER_ALREADY_OPEN: 'Mini browser window already opened and trying to change name',
        CANNOT_WRITE_TO_MINI_BROWSER: 'unable to write to minibrowser',
        BUYER_CANCELLED_TRANSACTION: 'Buyer cancelled the transaction',
        SETUP_MISSING_ELEMENT: 'IC_SETUP_CONTAINER_ERROR: Can\'t find element ',
        IC_INITXO_CALLED_BEFORE_SETUP: 'paypal.checkout.initXO() was called before calling paypal.checkout.setup(). Please call paypal.checkout.setup() first.',
        IC_STARTFLOW_CALLED_BEFORE_SETUP: 'paypal.checkout.startFlow() was called before calling paypal.checkout.setup(). Please call paypal.checkout.setup() first.'
    },

    FOCUSABLE_ELEMENTS: [
        'a[href]',
        'area[href]',
        'input',
        'select',
        'textarea',
        'button',
        'iframe',
        'object',
        'embed',
        '[tabindex]',
        '[contenteditable]'
    ]
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/constants.js
 ** module id = 8
 ** module chunks = 0
 **/